import { ethers } from 'ethers'

export const PAYMENT_MODE_NATIVE = 0
export const PAYMENT_MODE_ERC20 = 1

export function buildPaymentUpdate({ mode, tokenAddress, amount, decimals }) {
    const normalizedMode = Number(mode)
    const isNative = normalizedMode === PAYMENT_MODE_NATIVE

    return {
        mode: normalizedMode,
        tokenAddress: isNative ? ethers.constants.AddressZero : ethers.utils.getAddress(tokenAddress),
        amountRaw: ethers.utils.parseUnits(String(amount), isNative ? 18 : Number(decimals)),
    }
}

export function normalizePaymentConfig(result) {
    return {
        mode: Number(result[0].toString()),
        tokenAddress: result[1],
        priceRaw: ethers.BigNumber.from(result[2]),
        version: Number(result[3].toString()),
        createdBlock: Number(result[4].toString()),
    }
}

export function formatPaymentAmount(amountRaw, decimals) {
    return ethers.utils.formatUnits(ethers.BigNumber.from(amountRaw), Number(decimals))
}

export function multiplyPaymentAmount(amountRaw, quantity) {
    const normalizedQuantity = Number(quantity)
    if (!Number.isSafeInteger(normalizedQuantity) || normalizedQuantity <= 0) {
        throw new Error('Mint quantity must be a positive integer')
    }
    return ethers.BigNumber.from(amountRaw).mul(normalizedQuantity)
}

export function buildMintCall({ templateId, inviter, amount, value, configVersion }) {
    if (Number(templateId) === 2) {
        return {
            functionName: 'mintWithConfigVersion',
            args: [inviter, amount, value, Number(configVersion)],
        }
    }

    return {
        functionName: 'mint',
        args: [inviter, amount, value],
    }
}
